// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export type TraduccionCmpGdprNVendorsParams = Record<"num_vendors", string>;

export class TraduccionCmpGdprNVendors extends TraduccionLiteral<TraduccionCmpGdprNVendorsParams> {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.n_vendors";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprNVendors {
        this.VALUES ??= this.completar({
            "valor": {
                "ca": "{{num_vendors}} socis",
                "cs": "{{num_vendors}} partnerů",
                "da": "{{num_vendors}} partnere",
                "de": "{{num_vendors}} Partner",
                "en": "{{num_vendors}} partners",
                "es": "{{num_vendors}} socios",
                "eu": "{{num_vendors}} bazkide",
                "fi": "{{num_vendors}} kumppanit",
                "fr": "partenaires {{num_vendors}}",
                "gl": "{{num_vendors}} socios",
                "hi": "{{num_vendors}} भागीदार",
                "hu": "{{num_vendors}} partnerek",
                "it": "{{num_vendors}} terze parti",
                "nl": "{{num_vendors}} leden",
                "no": "{{num_vendors}} partnere",
                "pl": "partnerzy {{num_vendors}}",
                "pt": "{{num_vendors}} parceiros",
                "ro": "{{num_vendors}} parteneri",
                "ru": "{{num_vendors}} партнеров",
                "sk": "{{num_vendors}} partneri",
                "sv": "{{num_vendors}} partners",
                "tr": "{{num_vendors}} ortaklar"
            },
            "defecto": "{{num_vendors}} vendors"
        }, idiomas);

        return super.build(lang, this.VALUES, ["num_vendors"]);
    }

    /* INSTANCE */
}
